<div class="content">


  <div class="form-groups-row buffer-bottom">
    <div class="form-group">
      <label>Companies *</label>
      <app-company-picker [accountId]="equip.company_Id" (onCompanySet)="onCompanyChange($event)"></app-company-picker>
    </div>

    <div class="form-group">
      <label>Locations *</label>
      <app-location-picker [locationId]="equip.location_Id" [companyId]="equip.company_Id" (onLocationSet)="onLocationChange($event)"></app-location-picker>
    </div>

    <div class="form-group">
      <label>Report Type *</label>
      <app-report-type-picker [id]="equip.report_Type_Id" (onSet)="onReportTypeChange($event)"></app-report-type-picker>
    </div>
  </div>

  <div class="form-groups-row buffer-bottom">
    <div class="form-group">
      <label>Description *</label>
      <app-description-picker [id]="equip.item_Code" (onSet)="onDescriptionChange($event)"></app-description-picker>
    </div>
    <div class="form-group">
      <label >Serial # *</label>
      <input type="text" class="form-control" [(ngModel)]="equip.serial_Num" />
    </div>

    <div class="form-group">
      <label>Plant #</label>
      <input type="text" class="form-control" [(ngModel)]="equip.asset_Num" />
    </div>
  </div>
  <div class="form-groups-row buffer-bottom">
    <div class="form-group">
      <label *ngIf="equip.report_Type_Id == 5 || equip.report_Type_Id == 16">SWL</label>
      <label *ngIf="equip.report_Type_Id != 5 && equip.report_Type_Id != 16">SWL*</label>
      <input type="text" class="form-control" [(ngModel)]="equip.swl" />
    </div>
    <div class="form-group">
      <label>Model</label>
      <input type="text" class="form-control" [(ngModel)]="equip.model" />
    </div>

    <div class="form-group">
      <label>Make *</label>
      <input type="text" class="form-control" [(ngModel)]="equip.make" />
    </div>


  </div>
  <div class="form-groups-row buffer-bottom">
    <div class="form-group">
      <label>Internal Location</label>
      <input type="text" class="form-control" [(ngModel)]="equip.internal_Location" />
    </div>

    
    <div class="form-group">
    </div>


  </div>



  <div class="action-buttons">
    <button class="btn btn-primary" (click)="save()">Save</button>
    <div class="spacer"></div>
    <button class="btn btn-back" (click)="back()">Back</button>
  </div>
</div>
